import * as Sentry from '@sentry/sveltekit';
import { handleFetch, handleFetchReject, server_name, handle_fetch } from '$lib/app/lib';
import { patch } from "jsondiffpatch";
import { is_osm_uid } from '$lib/universal/lib';

export const activeUserData = {
    get data() { return data },
    set data(newData) { data = newData },
}

let data = $state({});
    
export function loadActiveUserData(userpage, { token } = {}) {
    console.log(`loadActiveUserData(/query-visits/${userpage})`);

    if(!userpage) {
        console.log(`resetting activeUserData`);
        activeUserData.data = {};
        return;
    }

    fetch(server_name('/query-visits/'+userpage), {
        method: 'GET',
        credentials: 'same-origin',
        ...(token && { headers: { Authorization: `Bearer ${token}` } })
    })
    .then(handleFetch, handleFetchReject)
    .then((json) => {
        if(json?.error) {
            console.error(`loadActiveUserData(${userpage}): Error loading activeUserData: `+JSON.stringify(json));
            Sentry.captureMessage("loadActiveUserData(): Error loading activeUserData", { extra: { userpage, error: json }});
            activeUserData.json = {};
        } else if(json?.status == 200) {
            json.userpage = userpage;
            data = json;
            //console.log(`loadActiveUserData(${userpage}): OK. data = ${JSON.stringify(data)}`);
        }
    });
}

export async function loadActiveUserDataAsync(userpage, { token } = {}) {
    //console.log(`loadActiveUserDataAsync(/query-visits/${userpage})`);

    if (!userpage) {
        console.log(`resetting activeUserData`);
        activeUserData.data = {};
        return undefined;
    }

    try {
        const response = await fetch(server_name(`/query-visits/${userpage}`), {
            method: 'GET',
            credentials: 'same-origin',
            ...(token && { headers: { Authorization: `Bearer ${token}` } })
        });

        const json = await handle_fetch(response);

        if (json?.error) {
            console.log(`loadActiveUserDataAsync(${userpage}): Error loading activeUserData: `+JSON.stringify(json));
            Sentry.captureMessage("loadActiveUserDataAsync(): Error loading activeUserData", { extra: { userpage, error: json }});
            activeUserData.json = {};
            return undefined;
        } else if (json?.status == 200) {
            json.userpage = userpage;
            data = json;
            console.log(`loadActiveUserDataAsync(${userpage}): OK`);
            //console.log(`loadActiveUserDataAsync(${userpage}): OK. data = ${JSON.stringify(json)}`);
            return json;
        }

        return undefined;
    } catch (error) {
        console.error(`loadActiveUserData(${userpage}): Fetch failed`, error);
        Sentry.captureMessage("loadActiveUserDataAsync(): Error loading activeUserData", { extra: { userpage, error: json }});
        return undefined;
    }
}

export function patchActiveUserData(delta) {
    if(!data?.userpage) {
        console.log("patchActiveUserData(): Empty activeUserData (no data.userpage), patch stopped. delta="+JSON.stringify(delta));
        Sentry.captureMessage("patchActiveUserData(): Empty activeUserData (no data.userpage), patch stopped", { extra: { delta: delta } });
    } else if(Array.isArray(delta)) { // That's actually workaround, because we only want object patches (not replacements)
        console.log("patchActiveUserData(): [] delta format is not supported. delta="+JSON.stringify(delta));
        Sentry.captureMessage("patchActiveUserData(): [] delta format is not supported, patch stopped", { extra: { delta: delta } });
    } else {
        patch(data, delta);
    }
}

/*
export function isVisitedPlace(osm_uid) {
    const features = data?.features;

    return features && features.find(feature => feature.properties.id === osm_uid);
}
*/

export function get_osm_uid_state(myData, osm_uid) {
    const features = myData?.features;

    if(features && is_osm_uid(osm_uid)) {
        const feature = features.find(f => f.properties.id === osm_uid);
        if (feature) {
            return {
                osm_uid,
                visited: true,
                transit: feature?.properties?.T,
                hidden: feature?.properties?.H
            }
        }
    } 
    return { osm_uid, visited: false, transit: undefined, hidden: undefined }
}

/*
export function mark_visited_places(list) {
    const features = data?.features;

    if(features) {
        const visited = {};
        //const idSet = new Set(features.map(feature => feature.properties.id));
        features.forEach(el => {
            const { id, T, H } = el.properties;
            if (id) {
                visited[id] = { T, H };
            }
        });
        
        
        //el.already_visited = idSet.has(el.osm_uid)
        list.forEach(el => {
            if (el.osm_uid in visited) {
                const visit = visited[el.osm_uid];
                el.visited = true;
                el.transit = visit?.T;
                el.hidden = visit?.H;
            }
        });
    }
    return list;
}
*/
